export const VERSIONS = [
    {
        version: '2.1',
        changelog: [
            'Topups has been renamed to Drawdowns. Drawdowns are entities/documents against which a borrower can request for withdrawal from credit line',
            "All the approvals have been moved to a single dropdown called 'Approvals'",
        ],
    },
];
